import { externalLinks } from "@/utils/external-links";

export const banners = [
  {
    title: "Recupere o que é seu por direito.",
    subtitle: "Recupere impostos pagos a mais sem risco e sem complicação.",
    ctaText: "ENTRAR EM CONTATO",
    ctaLink: externalLinks.whatsapp,
    image: "/cropped_woman.png",
  },
  {
    title: "Soluções sob medida para o Simples Nacional.",
    subtitle: "Soluções tributárias especializadas para empresas do Simples Nacional.",
    ctaText: "ENTRAR EM CONTATO",
    ctaLink: externalLinks.whatsapp,
    image: "/cropped_man.png",
  },
  {
    title: "Pague apenas o que é justo.",
    subtitle: "Auditoria de produtos: evite pagar imposto indevido.",
    ctaText: "ENTRAR EM CONTATO",
    ctaLink: externalLinks.whatsapp,
    image: "/cropped_woman_3.png",
  },
  {
    title: "Economia garantida já no próximo mês.",
    subtitle: "Monitoramento tributário: descontos direto na guia do mês seguinte.",
    ctaText: "ENTRAR EM CONTATO",
    ctaLink: externalLinks.whatsapp,
    image: "/cropped_man_2.png",
  },
  {
    title: "Mais força para o seu escritório contábil.",
    subtitle: "Parceria com contadores: fortalecemos sua contabilidade.",
    ctaText: "ENTRAR EM CONTATO",
    ctaLink: externalLinks.whatsapp,
    image: "/cropped_man_4.png",
  },
  {
    title: "Leve nossas soluções para sua região.",
    subtitle: "Seja representante dos nossos serviços.",
    ctaText: "ENTRAR EM CONTATO",
    ctaLink: externalLinks.whatsapp,
    image: "/cropped_man_3.png",
  },
];
